/**
 * Advertisement banner constants — placement & targeting.
 */

export const PAGE_TYPES = {
  HOME: "HOME",
  SECTION: "SECTION",
  CONTENT: "CONTENT",
  EXTERNAL: "EXTERNAL",
};

export const PAGE_TYPE_OPTIONS = [
  { value: PAGE_TYPES.HOME, label: "Home Page" },
  { value: PAGE_TYPES.SECTION, label: "Section Page" },
  { value: PAGE_TYPES.CONTENT, label: "Content Detail Page" },
];

export const ADVERTISEMENT_POSITION_OPTIONS = [
  { value: "SIDEBAR", label: "Sidebar" },
  { value: "FOOTER", label: "Footer" },
];

export const PAGE_TYPES_WITH_REFERENCE = [
  PAGE_TYPES.SECTION,
  PAGE_TYPES.CONTENT,
];

export const ALLOWED_AD_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
];

export const ALLOWED_AD_IMAGE_ACCEPT =
  "image/jpeg,image/jpg,image/png,image/webp";

export const AD_SCHEDULE_STATUS = {
  UPCOMING: "Upcoming",
  ACTIVE: "Active",
  EXPIRED: "Expired",
};
